import React from 'react';

export const name = 'flag-EE';

export const FlagEE = () => (
  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_2_135)">
      <mask
        id="mask0_2_135"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="24"
        height="24"
      >
        <path d="M24 0H0V24H24V0Z" fill="white" />
      </mask>
      <g mask="url(#mask0_2_135)">
        <path
          d="M2.8954e-09 12C2.8954e-09 13.4672 0.2625 14.8734 0.75 16.1719L12 16.6969L23.25 16.1719C24.2505 13.4806 24.2505 10.5194 23.25 7.82813L12 7.30313L0.75 7.82813C0.253946 9.16308 -3.13118e-05 10.5758 2.8954e-09 12Z"
          fill="#333333"
        />
        <path
          d="M12 0C9.54989 0.000299071 7.15861 0.750567 5.14748 2.14997C3.13636 3.54938 1.60179 5.53088 0.75 7.82812H23.25C22.3982 5.53088 20.8636 3.54938 18.8525 2.14997C16.8414 0.750567 14.4501 0.000299071 12 0Z"
          fill="#0052B4"
        />
        <path
          d="M23.25 16.1719H0.75C1.60243 18.4684 3.13728 20.449 5.14838 21.8477C7.15941 23.2463 9.55036 23.9961 12 23.9961C14.4496 23.9961 16.8406 23.2463 18.8516 21.8477C20.8627 20.449 22.3976 18.4684 23.25 16.1719Z"
          fill="#EEEEEE"
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_2_135">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
